import React from 'react';
import classNames from 'classnames';

import css from './IconCustomClose.module.css';

const IconCustomClose = props => {
  const { className, rootClassName, small = false } = props;
  const classes = classNames(rootClassName || css.root, className);

  if (small) {
    return (
      <svg className={classes} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4.00002L12 12M4 12L12 4" stroke="#00113D" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }

  return (
    <svg className={classes} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.0059 1L1.00586 17" stroke="#6E7191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1.00586 1L17.0059 17" stroke="#6E7191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default IconCustomClose;
